module.exports = __webpack_public_path__ + "img/add-user.fbe36cc5.png";